const initialState = {
    data: [],
  };
  
const rozliczenieWodyMSavedReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ROZLICZENIE_WODY_M':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default rozliczenieWodyMSavedReducer;